import { CustomState } from "@iewcasia/Store/Reducers";
import { CheckoutReviewAndSubmitStateType } from "@iewcasia/Store/State/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitState";
import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        onCalendar?: boolean;
        estimateShipDateOrderChanged?: boolean;
        cartLines?:
            | {
                  id: string;
                  estimateShipDate: string;
              }[]
            | [];
        cartEstimateShipDate?: string;
        paymentMethodChanged?: boolean;
    },
    CheckoutReviewAndSubmitStateType
>;

export const LoadShipOnCalendar: HandlerType = props => {
    if (props.parameter.onCalendar == null) {
        return;
    }
    props.dispatch({
        type: "Custom/CheckoutReviewAndSubmit/ShippingDetails",
        onCalendar: props.parameter.onCalendar,
    } as any);
};

export const LoadEstimateShipDateOrderChanged: HandlerType = props => {
    if (props.parameter.estimateShipDateOrderChanged !== undefined) {
        props.dispatch({
            type: "Custom/CheckoutReviewAndSubmit/EstimateShipDateOrderChanged",
            estimateShipDateOrderChanged: props.parameter.estimateShipDateOrderChanged,
        } as any);
    }
};

export const LoadCartEstimateShip: HandlerType = props => {
    if (!props.parameter.cartEstimateShipDate) {
        return;
    }

    props.dispatch({
        type: "Custom/CheckoutReviewAndSubmit/CartEstimateShipDateOrderChanged",
        cartEstimateShipDate: props.parameter.cartEstimateShipDate,
    } as any);
};

export const LoadCartLinesEstimateShip: HandlerType = props => {
    if (!props.parameter.cartLines) {
        return;
    }

    props.dispatch({
        type: "Custom/CheckoutReviewAndSubmit/SetCartLineEstimateShip",
        cartLines: props.parameter.cartLines,
    } as any);
};

export const chain = [
    LoadShipOnCalendar,
    LoadEstimateShipDateOrderChanged,
    LoadCartEstimateShip,
    LoadCartLinesEstimateShip,
];

const setCustomShippingDetails = createHandlerChainRunner(chain, "SetShippingMethod");
export default setCustomShippingDetails;
